import { combineReducers } from 'redux'
import userReducer from './userReducer'
import landingReducer from './landingReducer'
import sidebarReducer from './sidebarReducer'
import gamelistReducer from './gamelistReducer'
import challengeModalReducer from './challengeModalReducer'
import viewChallengeModalReducer from './viewChallengeModalReducer'
import viewRequestModalReducer from './viewRequestModalReducer'
import alertModalReducer from './alertModalReducer'
import friendListReducer from './friendListReducer'

const reducers = combineReducers({
  username: userReducer,
  selectedLogin: landingReducer,
  sidebar: sidebarReducer,
  gameList: gamelistReducer,
  challengeModal: challengeModalReducer,
  viewRequestModal: viewRequestModalReducer,
  viewChallengeModal: viewChallengeModalReducer,
  alertModal: alertModalReducer,
  friendList: friendListReducer,
})

export default reducers



/** WEBPACK FOOTER **
 ** ./src/reducers/index.js
 **/